import * as InternalTypes from '../common/InternalTypes';

export class ThemingConfig {
	private readonly _writeToGlobals: boolean = false;
	private readonly _writeCssInlineStyle: boolean = false;
	private readonly _writeCssLinkTag: boolean = false;
	private readonly _cssLinkTagUrl?: string;

	constructor(themingConfig: InternalTypes.ThemingConfig) {
		this._writeToGlobals = themingConfig.writeToGlobals;
		this._writeCssInlineStyle = themingConfig.writeCssInlineStyle || false;
		this._writeCssLinkTag = themingConfig.writeCssLinkTag || false;
		this._cssLinkTagUrl = themingConfig.cssLinkTagUrl;
	}

	get writeToGlobals(): boolean {
		return this._writeToGlobals;
	}

	get writeCssInlineStyle(): boolean {
		return this._writeCssInlineStyle;
	}

	get writeCssLinkTag(): boolean {
		return this._writeCssLinkTag;
	}

	get cssLinkTagUrl(): string | undefined {
		return this._cssLinkTagUrl;
	}
}
